import { useGetVendedoresDashboardQuery } from "../../../../api/vendedorApi";
import { DashboardVendedorFilters } from "../../../../types/filter";
import { CardEmpresasVendedor } from "./CardEmpresasVendedor";
import { ErrorMessage } from "../../../../components/errors/ErrorMessage";
import { CircularProgress } from "@mui/joy";

interface Props {
    filters: DashboardVendedorFilters;
}

export function VendedoresList( { filters }: Props) {
    const { 
        data: vendedores,
        isLoading,
        isFetching,
        isSuccess,
        isError,
    } = useGetVendedoresDashboardQuery(filters);

    if(isError)
        return (
        <div>
            <ErrorMessage customMessage>
                Ha ocurrido un error al cargar los vendedores 
            </ErrorMessage>
        </div>)

    return (
        <div
            className="flex flex-wrap justify-center gap-x-2 gap-y-2 h-full overflow-auto">
            {isLoading || isFetching || !isSuccess
            ?
            <div className="flex w-full h-full justify-center items-center ">
                <CircularProgress />
            </div>
            :
            <>
            {vendedores.length != undefined && vendedores.length > 0
            ?
            <>
            {vendedores.map((vendedor, index) => (
                <CardEmpresasVendedor
                    key={index}
                    vendedor={vendedor}/>
            ))}
            </>
            :
            <div>
                <p className="font-semibold text-3xl">Sin vendedores</p>
            </div>
            }
            </>
            }
        </div>
    );
}
